import PropTypes from "prop-types";
import usePermission from "../../hooks/usePermission";

// Wrapper that conditionally renders its children based on the current
// user's permissions (user.data.permissions in Redux). Mirrors the "at
// least one of these permissions" semantics already used by
// src/router/routeGuard.js and src/const/links.js.
//
// Usage:
//   <PermissionGate permission="analytics:messages:view">
//     <MessageAnalyticsWidgets ... />
//   </PermissionGate>
//
//   <PermissionGate permission={["analytics:campaigns:view", "agent"]} fallback={<EmptyState />}>
//     <ClientCampaignAnalyticsDashboard ... />
//   </PermissionGate>
const PermissionGate = ({ permission, fallback, children }) => {
  const { hasAnyPermission } = usePermission();

  if (!hasAnyPermission(permission)) {
    return fallback || null;
  }

  return children;
};

PermissionGate.propTypes = {
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
    .isRequired,
  fallback: PropTypes.node,
  children: PropTypes.node,
};

PermissionGate.defaultProps = {
  fallback: null,
  children: null,
};

export default PermissionGate;
